import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header-bar" }
const _hoisted_2 = { class: "header-bar__logo" }
const _hoisted_3 = {
  key: 0,
  class: "header-bar__menu"
}
const _hoisted_4 = { class: "header-bar__actions" }

import { useAppStore } from '@/stores/app.store';


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderBar',
  setup(__props) {

const appStore = useAppStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "logo")
    ]),
    (_unref(appStore))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "mega-menu")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "actions")
    ])
  ]))
}
}

})